export default __webpack_public_path__ + "static/media/resettle.9e2cb395.jpg";